<template>
 <div class="terms-amazsd-69 terms-ecs-2022">
  <div class="eventInformation">
   <v-container>
    <v-layout>
     <v-flex md8 xs12 class="terms" v-if="!this.event">
      <h3>One moment please.</h3>
      <p>If this message persists, we may have encountered a problem. Please email <a href="mailto:amaze@rti.org">amaze@rti.org</a> and let us know.</p>
     </v-flex>
     <v-flex md8 xs12 class="terms" v-else>

      <h3>Waiver and Release Form</h3>

      <div>
       <p>I, the undersigned ("Participant"), in consideration for my voluntary participation in the <strong>{{event}}</strong> on <strong>{{event_date}}</strong>, hosted by Research Triangle Institute, under the trade name RTI International (RTI) at the McKimmon Conference and Training Center at NC State University, 1101 Gorman Street, Raleigh, NC 27606 (“Conference”), do hereby willfully acknowledge that my electronic acceptance attests to my understanding and agreement that:
       </p>

       <h4>COVID-19 DISCLAIMER AND MODIFICATIONS</h4>
       <p>Given the unprecedented changes to business-as-usual resulting from the COVID-19 pandemic, RTI may need to adjust the proposed Conference dates on an as needed basis to protect Participants and RTI and remain in compliance with current public health restrictions. RTI shall notify Participants in writing for any changes to the Conference that may be required. Currently, RTI plans to offer both in-person and virtual or blended participation options but will make more final decisions as the Conference dates approach</p>

       <p>For more information on the McKimmon Center visitor policies, please refer to their website for the most up-to-date guidance and community standards/protocols. If a Participant feels sick, please utilize the virtual option and do not attend the Conference in-person. Please see <a href="https://www.ncsu.edu/coronavirus/" target="_blank">https://www.ncsu.edu/coronavirus/</a> and <a href="https://mckimmoncenter.ncsu.edu/mctc/criteria/" target="_blank">https://mckimmoncenter.ncsu.edu/mctc/criteria/</a> for more information on the NC State University policies. Visitors must comply with all local and state laws and ordinances.</p>

       <h4>ADMITTANCE</h4>
       <p>In our sole discretion, without refund, RTI reserves the right to refuse admittance to or expel (virtually or in-person) from the Conference anyone that we determine is behaving in a manner that could be disruptive to the Conference or any other.</p>

       <h4>VISITOR TAGS</h4>
       <p>Participants will be issued a visitor tag upon entering the McKimmon Center and signing in at the Registration Table. Participants will display the tags while attending the Conference. Tags are valid for named Participant only and cannot be transferred. Participants may be asked for photographic ID during the Conference. If Participant is unable to provide identification, which matches the tag, Participant may be asked to leave the Conference. Tags will expire at the end of the Conference. Participants will restrict themselves to the areas designated for the Conference and in accordance with the Conference schedule/agenda.</p>

       <h4>PHOTOGRAPHY, AUDIO, AND VIDEO RECORDING</h4>
       <p>The Conference will be held at the McKimmon Conference and Training Center at NC State University, 1101 Gorman Street, Raleigh, NC 27606 (“Conference premises”). We prohibit participants, exhibitors, sponsors, news organizations and other companies from photographing or video or audio-taping some Conference activities. RTI reserves the right to use images taken at the Conference with your photograph and/or likeness in future marketing materials. RTI may edit, alter, copy, exhibit, distribute and publish in print, video, audio recorded productions, and on the World Wide Web material from the Conference for purposes of publicizing RTI programs or other lawful purpose without payment or any other consideration. The photography, audio and video recording will become the property of RTI, stored in a place chosen by RTI and will not be returned to me. In addition, I waive the right to inspect or approve the finished product, including written or electronic copy, wherein my likeness appears. I waive any right to royalties or other compensation arising or related to the use of the photography, audio and video recording.</p>

       <h4>ALCOHOL, DRUG, AND SMOKING DRUG POLICY</h4>
       <p>Alcohol will not be permitted on the Conference premises during the Conference. Participants found possessing or using illicit drugs, as defined by United States federal law, will be required to leave the Conference premises immediately and may be held criminally liable. RTI prohibits smoking on the Conference premises during the Conference.</p>

       <h4>VALUABLES</h4>
       <p>Participant is solely responsible for any valuables they decide to bring to the Conference. RTI is not responsible for belongings left on Conference premises.</p>

       <h4>LIABILITY</h4>
       <p>I, Participant, hereby release, waive liability, discharge, hold harmless, indemnify, and covenant not to sue the RTI or the Mc Kimmon Center or NC State University for any and all liability incurred in the conduct of, and my participation in, this Conference.</p>
       <p>Participant will report any and all injuries to RTI and McKimmon Center staff immediately. Should any medical emergency arise, Participant will first call 911.</p>
       <p>RTI executives are the only staff members empowered to grant exceptions to any Conference policies or other general RTI practices. I, Participant, will not liable hold RTI liable for any erroneous statements made by other staff members regarding exceptions to fees or policies. Purchase orders supplied by the payee for the registered Participant shall be for accounting identification purposes only, and any terms or conditions therein or in any acknowledgement, confirmation, or other communication by the Participant in addition to or in conflict with the Conference terms and conditions are rejected.</p>

      </div>
      <p>NAME: {{name}}<br />

       DATE: {{date}}</p>
      <div v-if="!accepted">
      <v-form ref="termsForm">
      <v-checkbox
       required
       v-model="terms"
       :rules="rules.terms"
      >
       <template slot='label'>By checking this box, you agree to the terms and conditions.<span class='star'>*</span></template>
      </v-checkbox>
      <v-btn
       class='ml-0'
       color="primary"
       @click="submitTerms()"
       v-if="!submitted"
      >Submit</v-btn>
      <v-progress-circular v-else indeterminate />

      </v-form>
      </div>
      <div v-else>
       <h4>Thank you!</h4>
       <p v-if="accepted_date">You accepted the terms and conditions <strong>{{accepted_date |localTime}} ago</strong>.</p>
       <p>Please be on the lookout for more messages from us as we lead up to the event.<br />We are looking forward to having you join us!</p>
      </div>
     </v-flex>
    </v-layout>
   </v-container>
  </div>
 </div>
</template>

<script>
export default {
  data() {
    return {
      user: null,
      name: "",
      date: new Date().toLocaleDateString(),
      event: "",
      event_date: "",
      event_waiver: "default",
      terms: null,
      accepted: false,
      accepted_date: null,
      submitted: false,
      rules: {
        terms: [
          v => !!v || "You must accept the terms and conditions to continue."
        ]
      }
    };
  },
  methods: {
    submitTerms() {
      if (this.$refs.termsForm.validate()) {
        this.submitted = true;
        this.$http
          .put("registration/terms/" + this.user.uuid, { terms: 1 })
          .then(response => {
            this.accepted = true;
            this.accepted_date = response.data.data[0].updated_at;
            this.$store.commit("updateMessage", {
              message: "The terms have been accepted.",
              snackbar: true
            });
          });
      }
    }
  },
  computed: {
    waiver: function() {
      // For now we assume that there are two flavors of waivers:
      // Default (on location) and virtual.
      switch (this.event_waiver.trim().toLowerCase()) {
        case 'virtual':
          return 'virtual';
        default:
          return 'default';
      }
    },
    defaultWaiver: function() {
      return this.waiver === 'default';
    },
    virtualWaiver: function() {
      return this.waiver === 'virtual';
    }
  },
  mounted() {
    if (!this.$route.params.uuid) {
    }
    this.$http.get("registration/terms/" + this.$route.params.uuid).then(
      response => {
        this.user = response.data.data[0];
        this.name = this.user.name;
        this.event = this.user.registration.registration_event.name;
        this.event_date = this.user.registration.registration_event.dates;
        this.event_waiver = this.user.registration.registration_event.content.waiver || "default";
        if (this.user.terms) {
          this.terms = this.user.terms;
          this.accepted = true;
          this.accepted_date = this.user.updated_at;
        }
        this.$store.commit("updateMessage", {
          message: "Please review the terms and conditions.",
          snackbar: true
        });
      },
      response => {
        this.$store.commit("updateMessage", {
          message:
       "Error: Your information was not found. Please contact support.",
          snackbar: true
        });
        this.$router.push({ path: "/event/missing-token" });
      }
    );
  }
};
</script>
